import { useNavigate } from 'react-router-dom';
import { useDispatch, useSelector } from 'react-redux';
import { AppDispatch } from '@/stores/store';
import classnames from 'classnames';
import { Langs } from '@/components/Global';
import { user, global } from '@/modules';

import { APP_LIST_TYPE, DatumStatus } from '@/service/apps/type/appList.d';

import styles from './AppItem.module.less';

type AppItemProp = {
  appInfo: APP_LIST_TYPE;
};

export const AppItem = ({ appInfo }: AppItemProp) => {
  const navigate = useNavigate();
  const dispatch = useDispatch<AppDispatch>();
  const userInfo = useSelector(user.selector.getUserInfoState);

  const StatusMap: { [key in `${DatumStatus}`]: React.ReactNode } = {
    STATUS_APPROVED: 'APPROVED',
    STATUS_DISCARD: 'DISCARD',
    STATUS_DRAFT: <Langs title="status0" />,
    STATUS_UNDER_REVIEW: <Langs title="status2" />,
    STATUS_REJECTED: <Langs title="status1" />,
    STATUS_UNSPECIFIED: 'UNSPECIFIED',
    STATUS_OFFLINE: 'OFFLINE',
    STATUS_ONLINE: <Langs title="status3" />,
    STATUS_RELEASE_UNDER_REVIEW: <Langs title="status17" />,
    STATUS_UPDATE_UNDER_REVIEW: <Langs title="status18" />,
    STATUS_RELEASE_REJECTED: <Langs title="status15" />,
    STATUS_UPDATE_REJECTED: <Langs title="status16" />,
  };

  const goAppDetail = async () => {
    dispatch(global.actions.setAppId({ id: appInfo.id }));
    navigate('/app/info');
  };

  return (
    <div className={styles.AppItemsBox} onClick={goAppDetail}>
      <div className={styles.imgs}>
        {appInfo.logos![0]?.url ? (
          <img src={appInfo.logos![0]?.url}></img>
        ) : (
          <img src="https://img.dsers.com/global/Frameimg.png" style={{ width: '100px' }} />
        )}
      </div>
      <div className={styles.bottom}>
        <p className={styles.name}>{appInfo.name}</p>
        <p
          className={classnames({
            [styles.status]: true,
            [styles[appInfo.status!]]: true,
          })}
        >
          {StatusMap[appInfo.status!]}
        </p>
        {appInfo.lastReview?.status === 'STATUS_UNDER_REVIEW' ? (
          <span className={styles.shenhez}>
            <Langs title="status2" />
          </span>
        ) : null}
      </div>
    </div>
  );
};
